import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { FormField } from '../../../dto/util/form-field';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { InteraccionDto } from '../../../dto/justino/interaccion.dto';
import { EquipoDto } from '../../../dto/justino/equipo.dto';
import { HerramientaDto } from '../../../dto/justino/herramienta.dto';
import e from 'express';

@Component({
  selector: 'app-modal-interaccion',
  templateUrl: './modal-interaccion.component.html',
  styleUrl: './modal-interaccion.component.scss',
})
export class ModalInteraccionComponent {
  @ViewChild('modalInteraccion')
  modalInteraccion!: ElementRef;
  interaccionFormGroup!: FormGroup;
  interaccionForm: FormField[] = [
    {
      name: 'texto',
      label: 'Texto',
      type: 'textarea',
      required: true,
      width: '12',
      visible: true,
      errorMessages: {
        required: 'El texto es requerido',
      },
    },
  ];

  actor: string = 'Ninguno';
  equipo: string = 'Ninguno';
  herramienta: string = 'Ninguno';
  vertice: string = 'Ninguno';
  esAbriendo: boolean = true;

  esTipo: boolean = false;
  esUsuario: boolean = false;
  esInstruccion: boolean = false;
  esHerramienta: boolean = false;
  esSalta: boolean = false;

  tipoInteraccion: string = 'Díalogo';

  @Input() vertices: string[] = [];
  @Input() isTools: boolean = false;
  @Input() listaEquipos: EquipoDto[] = [];
  @Input() herramientas: HerramientaDto[] = [];

  @Input() editFlag: boolean = false;
  @Input() interaccion: InteraccionDto | undefined = undefined;
  @Output() interaccionEmitter = new EventEmitter<any>();
  @Output() updatedEmitter = new EventEmitter<any>();

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.createForm();
  }

  createForm(): void {
    const formControls: any = {};
    this.interaccionForm.forEach(field => {
      const validators = [];
      if (field.required) {
        validators.push(Validators.required);
      }
      formControls[field.name] = [null, validators];
    });
    this.interaccionFormGroup = this.fb.group(formControls);
    this.fillFormWithData();
  }

  fillFormWithData(): void {
    if (this.editFlag && this.interaccion) {
      // Es edición
      this.interaccionFormGroup.patchValue({
        texto: this.interaccion.texto,
      });
      this.actor = this.interaccion.actor;
    } else {
      // Es creación
      if (this.interaccion) {
        this.actor = this.interaccion.actor;
      }
    }
  }

  getErrorMessage(field: string): string | null {
    const control = this.interaccionFormGroup.get(field);
    if (control?.invalid && control.touched) {
      const errorType = Object.keys(control.errors!)[0];
      return (
        this.interaccionForm.find(f => f.name === field)?.errorMessages?.[
          errorType
        ] || 'Campo inválido'
      );
    }
    return null;
  }

  uniqueNameValidator(existingElements: any[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      const nameExists = existingElements.some(
        el => el.Nombre.toLowerCase() === control.value.toLowerCase()
      );
      return nameExists ? { nameExists: true } : null;
    };
  }

  abrirCrear(interaccion: InteraccionDto | undefined) {
    this.editFlag = false;
    this.esAbriendo = !this.esAbriendo;
    this.interaccion = undefined;
    if (interaccion) {
      this.esTipo = true;
      if (interaccion.actor === 'Des. Usuario') {
        this.actor = 'Instrucción';
        this.esUsuario = false;
        this.esInstruccion = true;
        this.tipoInteraccion = interaccion.tipo;
        this.equipo = 'Expertos';
      } else {
        this.actor = interaccion.actor;
        if (interaccion.tipo === 'Llamada a equipo') {
          this.interaccion = interaccion;
          this.esUsuario = false;
        } else {
          this.esUsuario = true;
        }
        this.esInstruccion = true;
      }
    } else {
      this.esUsuario = true;
      this.esInstruccion = false;
      this.actor = 'Des. Usuario';
    }
    this.modalInteraccion.nativeElement.click();
  }

  abrirActualizar(interaccion: InteraccionDto) {
    this.esAbriendo = !this.esAbriendo;
    this.interaccion = interaccion;
    if (interaccion.tipo === 'Llamada a equipo') {
      this.esTipo = true;
      this.tipoInteraccion = 'Llamada a equipo';
      this.actor = 'Instrucción';
      this.equipo = interaccion.equipo || 'Ninguno';
      this.herramienta = interaccion.herramienta || 'Ninguno';
      this.esHerramienta = this.equipo === 'Operadores';
    } else if (interaccion.tipo === 'Respuesta de equipo') {
      this.actor = 'Instrucción';
      this.equipo = interaccion.equipo || 'Ninguno';
      this.tipoInteraccion = 'Respuesta de equipo';
    } else if (interaccion.tipo === 'Salta a') {
      this.esTipo = true;
      this.tipoInteraccion = 'Salta a';
      this.actor = 'Salto';
    }
    this.fillFormWithData();
    this.modalInteraccion.nativeElement.click();
  }

  abrirCerrarModal() {
    this.esAbriendo = !this.esAbriendo;
    this.modalInteraccion.nativeElement.click();
  }

  onChangeTipoInteraccion(event: any): void {
    this.tipoInteraccion = event.target.value;
    this.esSalta = this.tipoInteraccion === 'Salta';
  }

  onChangeEquipo(event: any): void {
    this.equipo = event.target.value;
    this.esHerramienta = this.equipo === 'Operadores';
    if (
      this.esHerramienta &&
      this.herramientas &&
      this.herramientas.length > 0
    ) {
      this.herramienta = this.herramientas[0].Nombre;
    }
  }

  onChangeHerramienta(event: any): void {
    this.herramienta = event.target;
  }

  onChangeVertice(event: any): void {
    this.vertice = event.target.value;
    this.interaccionFormGroup.patchValue({
      texto: `Salta a: ${this.vertice}`,
    });
  }

  onChangeActor(event: any) {
    this.actor = event.target.value;
  }

  resetForm(): void {
    this.esAbriendo = true;
    this.actor = 'Ninguno';
    this.equipo = 'Ninguno';
    this.herramienta = 'Ninguno';
    this.esTipo = false;
    this.esUsuario = false;
    this.esInstruccion = false;
    this.interaccion = undefined;
    this.esHerramienta = false;
    this.tipoInteraccion = 'Díalogo';
    this.interaccionFormGroup.reset();
  }

  submitForm(): void {
    if (this.interaccionFormGroup.valid) {
      if (this.editFlag && this.interaccion) {
        // Actualizar objeto
        this.interaccion.actor = this.actor;
        this.interaccion.equipo = this.equipo;
        this.interaccion.tipo = this.tipoInteraccion;
        this.interaccion.herramienta = this.herramienta;
        this.interaccion.texto = this.interaccionFormGroup.get('texto')?.value;
        this.updatedEmitter.emit(this.interaccion);
      } else {
        // Crear nuevo objeto
        if (this.actor === 'Instrucción') {
          if (this.interaccion?.tipo === 'Llamada a equipo') {
            this.tipoInteraccion = 'Respuesta de equipo';
          } else if (this.interaccion?.tipo === 'Respuesta de equipo') {
            this.tipoInteraccion = 'Retorno';
          }
        }
        if (this.tipoInteraccion === 'Salta a') {
          this.actor = 'Salto';
        }
        const dto = {
          texto: this.interaccionFormGroup.get('texto')?.value,
          tipo: this.tipoInteraccion,
          herramienta: this.herramienta,
          equipo: this.equipo,
          actor: this.actor,
        };
        this.interaccionEmitter.emit(dto);
      }
      this.actor = 'Ninguno';
      this.equipo = 'Ninguno';
      this.herramienta = 'Ninguno';
      this.esHerramienta = false;
      this.tipoInteraccion = 'Díalogo';
      this.abrirCerrarModal();
      this.interaccionFormGroup.reset();
    } else {
      this.interaccionFormGroup.markAllAsTouched();
    }
  }
}
